import { iosCustomUrlSchemes } from '@/models/hl-app/custom-url-scheme'
import {
  AlertSection,
  BaseViewModelBuilder,
  internalExported,
  NextPage,
  Status,
  ViewModel,
} from './view-model'

const hlAppOrderCompleteNextPage: NextPage = {
  path: iosCustomUrlSchemes.orderComplete,
  buttonLabel: '閉じる',
  autoRedirect: true,
  requireLogin: false,
}
const hlAppOrderHistoryNextPage: NextPage = {
  path: '/hlapp/direct/mypage/order',
  buttonLabel: '注文内容を確認する',
  autoRedirect: false,
  requireLogin: false,
}
const hlAppReorderNextPage: NextPage = {
  path: '/hlapp/direct/mypage/order',
  buttonLabel: '決済を再開する',
  autoRedirect: false,
  requireLogin: false,
}

export class HlAppViewModelBuilder extends BaseViewModelBuilder<HlAppViewModelBuilder> {
  static forPaymentSuccessfullyDone(): HlAppViewModelBuilder {
    return HlAppViewModelBuilder.createWithStatus(internalExported.paymentSuccessfullyDoneStatus)
  }
  static forPaymentError(): HlAppViewModelBuilder {
    return HlAppViewModelBuilder.createWithStatus(internalExported.paymentErrorStatus)
  }
  static forPaymentCanceled(): HlAppViewModelBuilder {
    return HlAppViewModelBuilder.createWithStatus(internalExported.paymentCanceledStatus)
  }
  static forUnexpectedError(): HlAppViewModelBuilder {
    return HlAppViewModelBuilder.createWithStatus(internalExported.unexpectedErrorStatus)
  }
  private static createWithStatus(status: Status): HlAppViewModelBuilder {
    return new HlAppViewModelBuilder(status, [], [], undefined)
  }

  addCheckOrderHistoryErrorMessage(): HlAppViewModelBuilder {
    return this.addErrorMessage(
      'ご注文内容は購入履歴をご確認ください。'
    )
  }
  addMaybeErrorErrorMessage(): HlAppViewModelBuilder {
    return this.addErrorMessage(
      '注文が正常に完了しなかった可能性があります。ご注文履歴をご確認ください。'
    )
  }
  addGuideToOrderHistoryErrorMessage(): HlAppViewModelBuilder {
    return this.addErrorMessage(
      'お手数ですが、念のためご購入履歴をご確認ください。'
    )
  }
  addGuideToReorderErrorMessage(): HlAppViewModelBuilder {
    return this.addErrorMessage(
      '決済処理でエラーが発生しました。お手数ですが注文履歴をご確認の上、決済手続きを再開してください。'
    )
  }

  withCheckOrderHistoryAlertSection(): HlAppViewModelBuilder {
    return this.withAlertSection(internalExported.checkOrderHistoryAlertSection)
  }
  withReorderAlertSection(): HlAppViewModelBuilder {
    return this.withAlertSection(internalExported.reorderAlertSection)
  }
  withReorderAlertSectionOnCancel(): HlAppViewModelBuilder {
    return this.withAlertSection(internalExported.reorderOnCancelAlertSection)
  }

  buildWithHlAppOrderComplete(): ViewModel {
    return this.buildWithNextPage(hlAppOrderCompleteNextPage)
  }
  buildWithHlAppOrderHistory(): ViewModel {
    return this.buildWithNextPage(hlAppOrderHistoryNextPage)
  }
  buildWithHlAppReorder(): ViewModel {
    return this.buildWithNextPage(hlAppReorderNextPage)
  }

  protected innerConstructor(
    status: Status,
    infoMessages: string[],
    errorMessages: string[],
    alertSection?: AlertSection
  ): HlAppViewModelBuilder {
    return new HlAppViewModelBuilder(status, infoMessages, errorMessages, alertSection)
  }
}
